module.exports = __webpack_public_path__ + "img/gb1235-76-12.prt.d25721e4.jpg";